<template>
    <div id="wrapper">
      <Sidebar></Sidebar>
      <!-- Content Wrapper -->
      <div id="content-wrapper" class="d-flex flex-column">

        <!-- Main Content -->
        <div id="content">

          <Topbar></Topbar>
          <!-- Begin Page Content -->
          <div class="container-fluid">

            <!-- Page Heading -->
             <router-link :to="{ name: 'Home'}" > CRCB Control Panel</router-link> > 
             <span>英文版類別管理</span>
            <h1 class="h3 mb-2 mt-2 text-gray-800">英文版類別管理</h1>

            <div class="alert alert-dismissible fade show" role="alert" :class="is_error?'alert-danger':'alert-success'" v-if="message != ''">
              {{message}}
              <button type="button" class="close" data-dismiss="alert" aria-label="Close" v-if="is_error">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="text-center" v-if="loading" >
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>  

            <!-- DataTales Example -->
            <div class="card shadow mb-4" v-if="!loading">
                <div class="card-header py-3">
                <button type="button" class="btn btn-primary" v-on:click="Add">新增</button>
                </div>
                <div class="card-body" v-if="datas.length == 0">
                </div>
                <div class="card-body" v-if="datas.length > 0">
                    <div class="form-group row">
                        <label for="section" class=" col-form-label" style="padding-left:0.75em;"><b>單元:</b></label>
                        <div class="col-sm-2">
                            <select class="custom-select" v-model="selected" @change="Switch();Get()"> 
                                <option v-for="(item) in datas" :key="item.id" :value="item.id" >{{item.data.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="table-responsive">
                  
                      <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                        <thead>
                          <tr>
                            <th width="70%">類別</th>
                            <th  style='min-width:150px'>功能</th>
                            <th>排序</th>
                          </tr>
                        </thead>
                        <draggable tag="tbody" v-model="list"  group="people" @start="drag=true" @end="drag=false;Update()" :disabled="disabled" >
                          
                            <tr v-for="(item) in list" :key="item.id">
                              <td>{{item.name}}</td>
                              <td>
                                <button type="button" class="btn btn-primary" v-on:click="Edit(item.id)">編輯</button>
                                <button type="button" class="btn btn-danger" v-on:click="Delete(item.id)">刪除</button>
                              </td>
                              <td>
                                <label style="cursor:grab"><i class="fas fa-sort"></i></label>
                              </td>
                            </tr>
                        </draggable>
                      </table>
                    </div>
                  
                </div>

                <!-- PopUp Modal-->
                <div class="modal fade" id="SectionModal" tabindex="-1" role="dialog" aria-labelledby="sectionModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                        <h5 class="modal-title" id="sectionModalLabel">單元列表管理</h5>
                        <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-8 title">類別</div>
                                <div class="col-4 title">功能</div>
                                <draggable v-model="datas" group="people" @start="drag=true" @end="drag=false;UpdateSection()" :diabled="disabled" class="col-12">
                                    <div class="row mt-3 pb-3 item" v-for="(item) in datas" :key="item.id">
                                        <div class="col-8">{{item.data.name}}</div>
                                        <div class="col-4"><label style="cursor:grab"><i class="fas fa-sort"></i></label></div>
                                    </div>
      
                                </draggable>
                            </div>
                    

                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-secondary" type="button" data-dismiss="modal">取消</button>
                        </div>
                    </div>
                    </div>
                </div>
            </div>

          </div>
          <!-- /.container-fluid -->

        </div>
        <!-- End of Main Content -->

        <Footer></Footer>

      </div>
      <!-- End of Content Wrapper -->
    </div>
</template>

<script>
import {fb, db } from '../firebase'
import Draggable from 'vuedraggable'
export default {
  name: 'Category',
  components: {
    Draggable
  },
  data () {
    return {
        datas:[],
        list:[],
        disabled:false,
        selected:'',
        loading:true,
        message:'',
        is_error:false
    }
  },
  mounted () {
    this.Get();
  },
  watch: {
    is_error:function() {
      if ( !this.is_error ) {
        var vm = this;
        setTimeout(function(){ vm.message = '' }, 2000);
      }
    },
    message:function() {
      if ( !this.is_error ) {
        var vm = this;
        setTimeout(function(){ vm.message = '' }, 2000);
      }
    } 
  },
  methods: {
    Switch() {
      
      this.list = this.datas.find(x => x.id === this.selected).data.list;
      this.list.sort( (d1, d2) => d2.order - d1.order);

    },
    Get(){
        this.datas = [];
        var vm = this;
        // 取得列表
        db.collection("category_en").get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                var data = {"id": doc.id, "data": doc.data()};
                this.datas.push(data);
            });
            this.datas.sort( (d1, d2) => d1.data.order - d2.data.order);
            if ( this.datas.length > 0 && this.selected == ''  ) {
              this.selected = this.datas[0].id; 
              this.Switch();
            } else {
              this.Switch();
            }
            this.loading = false;
            if ($.fn.DataTable.isDataTable('#dataTable')) {
              $('#dataTable').dataTable().fnClearTable();
              $('#dataTable').dataTable().fnDestroy();
            }

            vm.EnableTable();
        });
    },
    Add() {
      this.$router.push({name: 'Category_enAdd'}); 
    },
    Edit(id) {

      this.$router.push({name: 'Category_enEdit', params: { section_id: this.selected, id: id }});

    },
    Delete(id) {
      var vm = this;
        if ( confirm("確定要刪除?") ) {
            
            var name = this.datas.find(x=>x.id === this.selected).data.name;
            var list = this.datas.find(x=>x.id === this.selected).data.list;
            var index = list.findIndex(x=>x.id === id);
            list.splice(index, 1);

            var item = {
                name:name,
                list:list
            }

            db.collection("category_en").doc(this.selected).update(item)
            .then(() => {
                alert("刪除成功!");
                vm.Get();
            }).catch((error) => {
                console.log("Error getting document:", error);
            });

        }
    },
    Update() {

        this.disabled = true;
        var batch = db.batch();

        var name = this.datas.find(x=>x.id === this.selected).data.name;

        var tmp = [];
        var total = this.list.length;
        this.list.forEach(function(value, index, array){
            value.order = total--;
            tmp.push(value);
        });
        this.list = tmp;
        var sfRef = db.collection("category_en").doc(this.selected);

        var item = {
            name : name,
            list:this.list
        }
        batch.update(sfRef, item);
            
        batch.commit()
        .then(() => {
            this.disabled = false;
            this.message = "排序更新成功";
            this.is_error = false;
        }).catch(()=>{
            this.disabled = false;
            this.message = "排序更新成功";
            this.is_error = true;
        });

    },
    UpdateSection() {

        this.disabled = true;
        var batch = db.batch();

        this.datas.forEach(function(value, index, array){
            // Update the population of 'SF'
            var sfRef = db.collection("category_en").doc(value.id);
            batch.update(sfRef, {"order": index});
        });
        batch.commit()
        .then(() => {
            this.disabled = false;
            this.message = "排序更新成功";
            this.is_error = false;
        }).catch(()=>{
            this.disabled = false;
            this.message = "排序更新失敗";
            this.is_error = true;
        });

    }
  }
}
</script>
<style scoped>
.title, .item{
    border-bottom:1px solid #e3e6f0
}
.title {
    font-weight: 700;
}
th,td {
  border-top:1px solid #e3e6f0 !important;
  border-bottom: 0px;
  border-left: 0px;
  border-right: 0px;
}
th:last-child,td:last-child {
  border-right:1px solid #e3e6f0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/CategoryEN.vue